<template>
  <question-card @submit="submit" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
        <v-text-field
        autofocus
        outlined
          v-model="purchasePrice"
          ref="input"
          :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
          required
          type="numeric"
          inputmode="numeric"
          
      />
    </div>
  </question-card>
</template>

<script>
import QuestionCard from '@/components/QuestionCard.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'purchase-price-step',
  components: {
    QuestionCard,
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    purchasePrice:{
      get(){
        return this.questionnaireLead.PurchasePrice?
        '$'+parseInt(this.questionnaireLead.PurchasePrice).toLocaleString('en-US', { style: 'decimal', currency: 'USD' })
        :''
      },
      set(value){
        this.questionnaireLead.PurchasePrice=value.replace(/[^0-9]/g, '')
      }
    }
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
  created(){
    if(!this.questionnaireLead.PurchasePrice)
      this.$set(this.questionnaireLead, 'PurchasePrice','');
  }
};
</script>
